import { createSelector } from "reselect";

const _byId = (state) => state.addresses.byId;
const _allIds = (state) => state.addresses.allIds;

const allAddresses = createSelector(_byId, _allIds, (byId, allIds) =>
  allIds.map((id) => byId[id]),
);

const selectors = {
  allAddresses,
};

export default selectors;
